
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsTaxInvoiceAddressDialog extends Serenity.EntityDialog<PsTaxInvoiceAddressRow, any> {
        protected getFormKey() { return PsTaxInvoiceAddressForm.formKey; }
        protected getIdProperty() { return PsTaxInvoiceAddressRow.idProperty; }
        protected getLocalTextPrefix() { return PsTaxInvoiceAddressRow.localTextPrefix; }
        protected getNameProperty() { return PsTaxInvoiceAddressRow.nameProperty; }
        protected getService() { return PsTaxInvoiceAddressService.baseUrl; }
        protected getDeletePermission() { return PsTaxInvoiceAddressRow.deletePermission; }
        protected getInsertPermission() { return PsTaxInvoiceAddressRow.insertPermission; }
        protected getUpdatePermission() { return PsTaxInvoiceAddressRow.updatePermission; }

        protected form = new PsTaxInvoiceAddressForm(this.idPrefix);
        constructor() {
            super();
        this.form.CusTaxTypeFg.changeSelect2(async e => {
            // let RefDocNo = Q.toId(this.form.RefDocNo.value)
            this.RequestfieldbyType();
        });


         }

         private RequestfieldbyType(){
            let type = this.form.CusTaxTypeFg.value;
            if(type == "1"){
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;
                this.form.TaxPostalCode.element.toggleClass("required", true);
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);      
            }
            if(type == "2"){
                this.form.TaxId.element.toggleClass("required", true);
                this.form.TaxBranchName.element.toggleClass("required", true);
                this.form.TaxBranchNo.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, false);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, false);                
                this.form.TaxPostalCode.element.toggleClass("required", true);
            }
            if(type == "3"){
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;
                this.form.TaxPostalCode.element.toggleClass("required", false);
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);
                
            }
            if(type == "4"){
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;       
                this.form.TaxPostalCode.element.toggleClass("required", false); 
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);       
                
            }
         }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

                     
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            buttons.push({
                title: 'Read Id Card',
                cssClass: 'read-idcard-button text-blue',
                icon: 'fa fa-id-card',
                separator: true,
                onClick: () => {
                    if (!this.validateBeforeSave())
                        return;
                        
                    Q.confirm("ยืนยันการอ่านบัตรประชาชน?", () => {
                        Q.notifyInfo("กำลังอ่านบัตรประชาชน... กรุณารอสักครู่");
    
                        fetch('http://localhost:4466/api/idcard/read')
                            .then(response => response.json())
                            .then(result => {
                                if (result.success) {
                                    const cardData = result.data[0];
                                    if (cardData) {
                                        // Set form values from card data
                                        this.form.CusTaxTypeFg.value = "1";
                                        this.form.TaxId.value = cardData.citizenID || '';
                                        this.form.TaxInvName.value = cardData.thaiName || '';
                                        this.form.TaxInvAddressLine1.value = `${cardData.houseNo || ''} ${cardData.villageNo || ''} ${cardData.lane || ''} ${cardData.road || ''}`.trim();
                                        this.form.TaxInvAddressLine2.value = `${cardData.tambol || ''} ${cardData.amphur || ''}`.trim();
                                        this.form.TaxInvAddressLine3.value = cardData.province || '';

                                        var id = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbPid == cardData.citizenID);
                                        if (id != null) {
                                            this.form.MbId.value = id.MbId;
                                            this.form.TaxEmail.value = id.MbEmail ?? "";
                                            this.form.TelNo.value = id.MbTelNo ?? "";
                                            this.form.TaxPostalCode.value = id.MbZipCode ?? "";
                                            
                                            var checkmd = Q.tryFirst(PsTaxInvoiceAddressRow.getLookup().items, x => x.MbId == id.MbId);
                                            if (checkmd != null && this.entityId != checkmd.Id) {
                                                Q.warning('มีข้อมูล สมาชิกนี้อยู่แล้วในการออกใบกำกับภาษี โปรดตรวจสอบ');
                                                return;
                                            }
                                        }

                                        Q.notifySuccess("อ่านข้อมูลบัตรสำเร็จ");
                                    } else {
                                        Q.notifyError("ไม่พบข้อมูลบัตรประชาชน");
                                    }
                                } else {
                                    Q.notifyError(result.message);
                                }
                            })
                            .catch(error => {
                                Q.notifyError("เกิดข้อผิดพลาดในการเชื่อมต่อกับเครื่องอ่านบัตร: " + error.message);
                            });
                    });
                }
            });

            // buttons.push(
            //     {
            //         title: 'อ่านบัตรประชาชน',
            //         cssClass: 'read-card-button',
            //         icon: 'fa-id-card',
            //         hint: 'ctrl+i',
            //         hotkey: 'ctrl+i',
            //         onClick: () => {
            //             this.readCard();
            //         }
            //     }
            // );
            

            let CallPR: Serenity.ToolButton =
            {
                title: "",
                hint: "call Member",
                cssClass: "call",
                icon: "fa fa-level-down-alt",

                onClick: (e) => {

                    let orderNo = this.form.MbId.value
                    if (!Q.isEmptyOrNull(orderNo)) {

                        var id = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbId == orderNo).MbId;

                        Member.LookupMemberService.Retrieve(
                            {
                                EntityId: id
                            }, response => {

                                this.setHdDetails(response.Entity);                                

                            }
                        )
                    }
                }
            };
            buttons.push(CallPR);



            return buttons;
        }

        public setHdDetails(details: Member.LookupMemberRow) {
            
            this.form.TaxInvName.value = String(details.MbNameT ?? "");
            this.form.TaxId.value = String(details.MbPid ?? "");

            this.form.TaxInvAddressLine1.value = String(details.MbLineAddr1 ?? "");
            this.form.TaxInvAddressLine2.value = String(details.MbLineAddr2 ?? "");
            this.form.TaxInvAddressLine3.value = String(details.MbLineAddr3 ?? "");
            this.form.TelNo.value = String(details.MbTelNo ?? "");  
            this.form.TaxPostalCode.value = String(details.MbZipCode ?? "");  
            this.form.TaxEmail.value = String(details.MbEmail ?? "");  
                   

        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            
            this.toolbar.findButton('call').insertAfter(this.form.MbId.element)
            this.RequestfieldbyType();
        }

        // private readCard() {
        //     Q.serviceCall({
        //         url: Q.resolveUrl('~/Services/Csi/ReadCard'),
        //         onSuccess: (response: any) => {
        //             console.log(response);
        //             if (response.CitizenID != null) {
        //                 // นำข้อมูลที่ได้มาใส่ในฟอร์มสมาชิก
        //                 let data = response;
        //                 console.log(data);
        //                 this.form.CusTaxTypeFg.value = "1";
        //                 this.form.TaxId.value = data.CitizenID;
        //                 this.form.TaxInvName.value = data.ThaiName;                                             
        //                 this.form.TaxInvAddressLine1.value = `${data.HouseNo} ${data.VillageNo} ${data.Lane} ${data.Road}`;
        //                 this.form.TaxInvAddressLine2.value = `${data.Tambol} ${data.Amphur}`;
        //                 this.form.TaxInvAddressLine3.value = data.Province;
                        
        //                 var id = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbPid == data.CitizenID);
        //                 if (id != null) {
        //                     this.form.MbId.value = id.MbId;
        //                     this.form.TaxEmail.value = id.MbEmail ?? "";
        //                     this.form.TelNo.value = id.MbTelNo ?? "";
        //                     this.form.TaxPostalCode.value = id.MbZipCode ?? "";
                            
        //                     var checkmd = Q.tryFirst(PsTaxInvoiceAddressRow.getLookup().items, x => x.MbId == id.MbId);
        //                     console.log(checkmd);
        //                     console.log(this.entityId+"  "+ checkmd.Id);
        //                     if (checkmd != null && this.entityId != checkmd.Id) {
        //                         Q.warning('มีข้อมูล สมาชิกนี้อยู่แล้วในการออกใบกำกับภาษี โปรดตรวจสอบ');
        //                         return;
        //                     }
        //                 }                        

        //                 Q.notifySuccess('อ่านข้อมูลบัตรสำเร็จ');
        //             } else {
        //                 Q.notifyError(response.Error || 'เกิดข้อผิดพลาดในการอ่านบัตร');
        //             }
        //         },
        //         onError: (response: any) => {
        //             Q.notifyError(response.Error || 'เกิดข้อผิดพลาดในการอ่านบัตร');
        //         }
        //     });
        // }


    }
}